import { render, staticRenderFns } from "./property-commercial.vue?vue&type=template&id=1682574c"
import script from "./property-commercial.vue?vue&type=script&lang=js"
export * from "./property-commercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports